import { Badge } from '@modules/common/components/badge';

type StockIndicatorProps = {
  inStock?: boolean;
};

export default function StockIndicator({ inStock }: StockIndicatorProps) {
  const color = inStock ? 'green-outline' : 'red-outline';

  return (
    <Badge
      data-testid="stock-indicator"
      color={color}
      role="status"
      aria-live="polite"
      className="px-2.5 whitespace-nowrap"
      translate="no"
    >
      {inStock ? 'In Stock' : 'Out of Stock'}
    </Badge>
  );
}
